import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { DataServiceService } from '../data-service.service';
import { ErrorService } from '../error.service';
import { CampuscctvserviceService } from '../service/campuscctvservice.service';
import { ToastmessageService } from '../toastmessage.service';

@Component({
  selector: 'app-totaldvredit-dialog',
  templateUrl: './totaldvredit-dialog.component.html',
  styleUrls: ['./totaldvredit-dialog.component.scss']
})
export class TotaldvreditDialogComponent implements OnInit {

  showPassword: boolean = false;
  submitted = false;
  durationInSeconds = 3;
  horizontalPosition: MatSnackBarHorizontalPosition = 'end';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  myForm!: FormGroup;
  name: any;
  dvrdatalist: any;
  totaldvrdetails: any;
  showErrorForworkingDVR: boolean = false;
  uniqueCctvDetId: any;
  updateCCtvdetails: any;
  pwdeye: any;
  pwdslash: any;
  constructor(public dialogRef: MatDialogRef<TotaldvreditDialogComponent>, private fb: FormBuilder, private _snackBar: MatSnackBar, @Inject(MAT_DIALOG_DATA) public data: any, private spinner: NgxSpinnerService, private dataService: DataServiceService, private errorService: ErrorService, private campusservice: CampuscctvserviceService, private toast: ToastmessageService) { }

  ngOnInit(): void {
    console.log('dataCcctvDetid', this.data);

    // console.log('pwdeye',this.pwdeye);
    console.log('updateCCtvdetails', this.data.updateCCtvdetails);
    this.updateCCtvdetails = this.data.updateCCtvdetails

    this.uniqueCctvDetId = this.data.uniqueCctvDetId;
    this.myForm = this.fb.group({
      buildingname: ['', Validators.required],
      ipAddress: ['', Validators.required],
      rtspPortNo: ['', Validators.required],
      httpPortNo: ['', Validators.required],
      userName: ['', Validators.required],
      password: ['', Validators.required],
      dvrModelNumber: ['', Validators.required],
      // serialNumber: ['', Validators.required],
      maxNoOfChannels: ['', Validators.required],
      totalCamerasInstalled: ['', Validators.required],
      totalWorkingCameras: ['', Validators.required],
      rtspAuthentication: ['', Validators.required],
      imageFormat: ['1', Validators.required],
      dvrStatus: ['1', Validators.required]
      // view: [this.data?.view]
    });
    this.edit(this.updateCCtvdetails);
    this.pwdeye = this.updateCCtvdetails.password;
    // this.spinner.show();
    // this.campusservice.getcctvdetails(this.uniqueCctvDetId).subscribe(
    //   {
    //     next: (res: any) => {
    //       this.updateCCtvdetails = res;
    //       this.pwdeye = this.updateCCtvdetails.password;
    //       console.log('updateCCtvdetails', this.updateCCtvdetails);
    //       this.edit(this.updateCCtvdetails)
    //       this.spinner.hide();
    //     },
    //     error: (error: any) => {
    //       if (error.status === 422) {
    //         this.dialogRef.close();
    //         this.toast.showError("Internal Server Error in DVR/NVR");
    //       }
    //       this.spinner.hide();
    //     }
    //   }
    // )


  }



  submit() {
    this.submitted = true;
    const imagetosend = this.myForm.get('imageFormat')?.value === '1' ? 'JPEG' : 'NA';
    const dvrstatus = this.myForm.get('dvrStatus')?.value === '1' ? 'OPENED' : 'CLOSED';
    if (this.myForm.valid) {
      const payload = {
        "buildingId": this.data.data.buildingId,
        "buildingName": this.myForm.value.buildingname,
        "campusId": this.data.data.campusId,
        "campusName": this.data.data.campusName,
        "cctvDetId": this.data.data.cctvDetId ? this.data.data.cctvDetId : 0,
        "cityId": this.data.data.cityId,
        "cityName": this.data.data.cityName,
        "dvrStatus": dvrstatus,
        "httpPortNo": this.myForm.value.httpPortNo,
        "imageFormat": imagetosend,
        "ipAddress": this.myForm.value.ipAddress,
        "maxNoOfChannels": this.myForm.value.maxNoOfChannels,
        "modelNo": this.myForm.value.dvrModelNumber,
        "rtspAuthentication": this.myForm.value.rtspAuthentication,
        "rtspPortNo": this.myForm.value.rtspPortNo,
        "serialNo": this.data.data.serialNumber,
        "stateId": this.data.data.stateId,
        "stateName": this.data.data.stateName,
        "totalCamerasInstalled": this.myForm.value.totalCamerasInstalled,
        "totalWorkingCameras": this.myForm.value.totalWorkingCameras,
        "userName": this.myForm.value.userName,
        "password":this.myForm.value.password,
        "buildingFusionCode": '',
        "businessSegment": 'COLLEGE'
      }
      console.log('payload', payload);
      this.spinner.show();
      if (confirm('Do you want to save DVR Details')) {
        this.campusservice.postcctvdetails(payload).subscribe(
          {
            next: (res: any) => {
              this.totaldvrdetails = res;
              this.spinner.hide();
              console.log('DVR_SAVE', this.totaldvrdetails);
              // Show success message
              this._snackBar.open(this.totaldvrdetails.message, '', {
                horizontalPosition: this.horizontalPosition,
                verticalPosition: this.verticalPosition,
                duration: this.durationInSeconds * 1000,
                panelClass: 'app-notification-success',
              });
              // this.errorService.errorDisplay(200, 'Success', '');
              this.dialogRef.close('save');
            },
            error: (error) => {
              this.spinner.hide();
              console.log('error', error);
              this.errorService.errorDisplay(Number(error.status), 'Error', error.error.message);
            }
          }
        )
      } else {
        this.spinner.hide();
      }
    } else {
      this._snackBar.open('Please fill all input fields', '', {
        horizontalPosition: this.horizontalPosition,
        verticalPosition: this.verticalPosition,
        duration: this.durationInSeconds * 1000,
      });
      // this.dialogRef.close();
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  onTotalworking(event: any) {
    const totalinstall = this.myForm?.value?.totalCamerasInstalled;
    const totalworking = this.myForm?.value?.totalWorkingCameras;
    if (Number(totalinstall) < Number(totalworking)) {
      this.showErrorForworkingDVR = true;
    } else {
      this.showErrorForworkingDVR = false;
    }
  }

  edit(updateCCtvdetails: any) {
    console.log('patchvalue', updateCCtvdetails);
    if (updateCCtvdetails) {
      this.myForm.patchValue({
        buildingname: updateCCtvdetails.buildingName,
        ipAddress: updateCCtvdetails.ipAddress,
        rtspPortNo: updateCCtvdetails.rtspPortNo,
        httpPortNo: updateCCtvdetails.httpPortNo,
        userName: updateCCtvdetails.userName,
        password: updateCCtvdetails.password.trim(),
        dvrModelNumber: updateCCtvdetails.dvrModelNumber,
        // serialNumber: updateCCtvdetails.serialNumberDvr,
        maxNoOfChannels: updateCCtvdetails.maxNoOfChannels,
        totalCamerasInstalled: updateCCtvdetails.totalCamerasInstalled,
        totalWorkingCameras: updateCCtvdetails.totalConnected == 0 ? '0' : updateCCtvdetails.totalConnected,
        rtspAuthentication: updateCCtvdetails.rtspAuthentication,
      });
    }
    else {
      alert('NOT PATCH VALUES')
    }
  }

  eyeslash() {
    console.log('eye', this.pwdeye);
    this.spinner.show();
    this.campusservice.getpwddetails(this.pwdeye).subscribe(
      {
        next: (res: any) => {
          this.pwdslash = res;
          if (this.pwdslash) {
            this.myForm.get("password")?.setValue(this.pwdslash)
          }
          console.log('pwdslash', this.pwdslash);
          this.spinner.hide();
        },
        error: (error: any) => {
          this.spinner.hide();
        }
      }
    )
  }

}
